'use strict';

/*
 * Terrific Application Bootstrapping
 *  and other bootstraping topics.
 */
(function ($, window, document) {

	/**
  * Remove no-js class from HTML tag.
  *  Do it at the very beginning.
  */
	$(document.documentElement).removeClass('no-js');

	/**
  * Helper function, returns calculated 'em' value for pixel.
  *
  * @param {string} px Pixel incl. unit, e.g. '320px'
  * @param {boolean} addPixel True if it should add additional pixel
  * @returns {string} Calculated em value incl. unit, e.g. '27.0em'
  */
	var px2em = function px2em(px, addPixel) {
		var unitlessNumber = parseFloat(px);

		if (addPixel) {
			if (Modernizr.ipad) {
				unitlessNumber += 1.25;
			} else {
				unitlessNumber += 1.0;
			}
		}

		// nunitlessNumber / 16 => pixel to em ratio
		var em = Math.round(unitlessNumber / 16 * 100) / 100;

		return em + 'em';
	};

	/**
  * Define TerrificJS config object.
  * Passed while creating instance of T.Application(config), see below.
  * @type {{}}
  */
	var config = {};

	/**
  * Config:
  *  Breakpoints: Pixel Based. See corresponding Breakpoints in variables.less.
  */
	config.breakpoints = {
		phone: '480px',
		small: '768px',
		medium: '1024px',
		large: '1280px'
	};

	/**
  * Config:
  *  Breakpoints in "em": Calculated, @see @ratio-px2em
  */
	config.breakpoints_em = {
		phone_max: px2em(config.breakpoints.phone),
		small_min: px2em(config.breakpoints.phone, true),
		small_max: px2em(config.breakpoints.small),
		medium_min: px2em(config.breakpoints.small, true),
		medium_max: px2em(config.breakpoints.medium),
		large_min: px2em(config.breakpoints.medium, true),
		large_max: px2em(config.breakpoints.large),
		xlarge_min: px2em(config.breakpoints.large, true)
	};

	/**
  * Config:
  *  Media queries, "em" Based (calculated)
  */
	config.mediaQueries = {
		'phone-down': 'screen and (max-width: ' + config.breakpoints_em.phone_max + ')',
		'small-up': 'screen and (min-width: ' + config.breakpoints_em.small_min + ')',
		'small-down': 'screen and (max-width: ' + config.breakpoints_em.small_max + ')',
		'small': 'screen and (min-width: ' + config.breakpoints_em.small_min + ')' + (' and (max-width: ' + config.breakpoints_em.small_max + ')'),
		'medium-up': 'screen and (min-width: ' + config.breakpoints_em.medium_min + ')',
		'medium': 'screen and (min-width: ' + config.breakpoints_em.medium_min + ')' + (' and (max-width: ' + config.breakpoints_em.medium_max + ')'),
		'large-up': 'screen and (min-width: ' + config.breakpoints_em.large_min + ')',
		'large': 'screen and (min-width: ' + config.breakpoints_em.large_min + ')' + (' and (max-width: ' + config.breakpoints_em.large_max + ')'),
		'xlarge-up': 'screen and (min-width: ' + config.breakpoints_em.xlarge_min + ')'
	};

	/**
  * Config:
  *  dotJS Templating config
  */
	config.doTTemplateSettings = {
		evaluate: /\[\[([\s\S]+?)]]/g,
		interpolate: /\[\[=([\s\S]+?)]]/g,
		encode: /\[\[!([\s\S]+?)]]/g,
		use: /\[\[#([\s\S]+?)]]/g,
		define: /\[\[##\s*([\w.$]+)\s*(:|=)([\s\S]+?)#]]/g,
		conditional: /\[\[\?(\?)?\s*([\s\S]*?)\s*]]/g,
		iterate: /\[\[~\s*(?:]]|([\s\S]+?)\s*:\s*([\w$]+)\s*(?::\s*([\w$]+))?\s*]])/g,
		varname: 'it',
		strip: true,
		append: true,
		selfcontained: false
	};

	/**
  * On Document Ready
  */
	$(function () {

		// eslint-disable-next-line no-undef
		doT.templateSettings = config.doTTemplateSettings;

		var pageElem = $('body').get(0);
		var terrificApp = window.terrificApp = new T.Application(config);
		terrificApp.registerModule(pageElem, 'page-controller');
		terrificApp.registerModules();
		terrificApp.start().catch(function (err) {
			window.console.error(err);
		});
	});

	/**
  * Mock analytics for development.
  **/
	(function () {
		if (!window._paq) {
			window._paq = [];
		}
	})();
})(jQuery, window, document);